import { EditChangeLogEntryFormData } from '../../../../entities/ChangeLog/ChangeLog'
import {
    FormErrors,
    FormValidation,
    validateForm,
    validateRequiredString,
    validateVersionString,
} from '../../../../services/validationService'

export type EditChangeLogEntryFormErrors = FormErrors<EditChangeLogEntryFormData>

export const validateEditChangeLogEntryFormData = (
    formData: EditChangeLogEntryFormData,
): FormValidation<EditChangeLogEntryFormErrors> => {
    const errors: EditChangeLogEntryFormErrors = {
        id: validateRequiredString('id', formData.id),
        version: validateVersionString('version', formData.version),
        changes: validateRequiredString('changes', formData.changes),
        // `date` is not listed here as it is derived from DateInput + TimeInput, which can't produce an invalid value.
    }

    return validateForm<EditChangeLogEntryFormErrors>(errors)
}
